import React from 'react'
import { CButton, CCard, CCardText, CCardBody,
         CCardHeader, CImage, CRow, CCol,
         CCardFooter } from 'compat/coreui';

export default function Strain() {
    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="box add strains_page">
                    <h2>Your Checkins</h2>
                        <CRow>
                            <CCol lg={6}>
                                <CCard>
                                    <CCardHeader>
                                        <CImage src="/images/indica.jpg"  width="20%"/>
                                        <span>Blue Dreams</span>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CCardText>xyz</CCardText>
                                        <CCardFooter>
                                            <CRow className="m-0">
                                                <CCol lg={10} className="p-0"><span>Posted on 12/1/21</span></CCol>
                                                <CCol lg={2} className="p-0"><i class="fa fa-heart"></i></CCol>
                                            </CRow>
                                        </CCardFooter>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                            <CCol lg={6}>
                                <CCard>
                                    <CCardHeader>
                                        <CImage src="/images/indica.jpg"  width="20%"/>
                                        <span>Black Dreams</span>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CCardText>xyz</CCardText>
                                        <CCardFooter>
                                            <CRow className="m-0">
                                                <CCol lg={10} className="p-0"><span>Posted on 12/1/21</span></CCol>
                                                <CCol lg={2} className="p-0"><i class="fa fa-heart"></i></CCol>
                                            </CRow>
                                        </CCardFooter>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>
                    </div>
                </li>
            </ul>
        </>
    )
}